import { LOCAL__grid2d_upsert } from '@/state/grid2d/grid2d/LOCAL__grid2d_upsert';
import { store } from '@/state/store';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_generation } from '@shared/dto/grid2d/DTO__grid2d_generation';
import { recreate_chunk_indices_for_grid2d_user_task } from './recreate_chunk_indices_for_grid2d_user_task';

export function try_upsert_from_generation_to_user_task_grid2d_chunk(grid2d: DTO__grid2d) {
  if (grid2d.entity_type != ENUM__workspace_entity.ENTITY_GENERATION) return; //no need to update user task

  assert_instanceof(grid2d, DTO__grid2d_generation);

  let { slice_grid2d, slice_generation } = store.getState();

  let user_task = slice_generation.user_tasks_map.get(grid2d.user_task_id);
  if (!user_task) return; //not loaded yet

  let grid2d_task = slice_grid2d.grids2d_map.get(user_task._id);
  if (!grid2d_task) return; //not loaded yet

  let grid2d_chunk_task = grid2d.get_generation_chunk();

  grid2d_chunk_task = grid2d_chunk_task.clone();

  //keep only images with url_relative
  grid2d_chunk_task.cells_list = grid2d_chunk_task.cells_list.filter(cell => !cell.is_stub());

  grid2d_chunk_task.entity_type = ENUM__workspace_entity.ENTITY_USER_TASK;
  grid2d_chunk_task.grid2d_id = grid2d_task._id;

  grid2d_task.chunk__upsert(grid2d_chunk_task);

  recreate_chunk_indices_for_grid2d_user_task(grid2d_task);

  store.dispatch(LOCAL__grid2d_upsert([grid2d_task]));
}
